import { __decorate, __metadata } from "tslib";
import { Component, Prop, Ref } from "vue-property-decorator";
import LvModal from "../modal/LvModal.vue";
import LvButton from "../button/LvButton.vue";
import LvIcon from "../icon/LvIcon.vue";
import { Deferred } from "@fastoche/ui-core/async";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvMessageBox";
let LvMessageBox = class LvMessageBox extends UIComponent {
    constructor() {
        super(...arguments);
        this.deferred = null;
    }
    get icon() {
        switch (this.type) {
            case "success":
                return "las la-check-circle";
            case "warning":
                return "las la-exclamation-triangle";
            case "info":
                return "las la-info-circle";
            case "danger":
                return "las la-exclamation-circle";
        }
    }
    get buttonColor() {
        switch (this.type) {
            case "info":
            case "warning":
                return "primary";
            default:
                return this.type;
        }
    }
    prompt() {
        if (this.deferred)
            return this.deferred.promise;
        this.deferred = new Deferred();
        this.modal.show();
        return this.deferred.promise;
    }
    resolve(result) {
        this.modal.hide();
        this.deferred?.resolve(result);
        this.deferred = null;
    }
};
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", Object)
], LvMessageBox.prototype, "title", void 0);
__decorate([
    Prop({ type: String, required: true }),
    __metadata("design:type", String)
], LvMessageBox.prototype, "message", void 0);
__decorate([
    Prop({ type: String, required: false, default: "info" }),
    __metadata("design:type", String)
], LvMessageBox.prototype, "type", void 0);
__decorate([
    Prop({ type: String, required: true }),
    __metadata("design:type", String)
], LvMessageBox.prototype, "confirmText", void 0);
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", Object)
], LvMessageBox.prototype, "cancelText", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], LvMessageBox.prototype, "isCancellable", void 0);
__decorate([
    Ref(),
    __metadata("design:type", LvModal)
], LvMessageBox.prototype, "modal", void 0);
LvMessageBox = __decorate([
    Component({
        name: COMPONENT_NAME,
        components: { LvIcon, LvButton, LvModal },
    })
], LvMessageBox);
export default LvMessageBox;
//# sourceMappingURL=script.js.map